import { useState, useEffect } from 'react';
import Dropdown from './components/Dropdown';
import { searchContext } from '../../../Context/Context.jsx';
import SearchButton from '../../../global/SearchButton/SearchButton';
import SharedButton from '../../../global/Button/Button';
import { Items, SearchContext, SearchItem } from '../../../types';
import { tagMapping } from './helpers';
import { useLocation, useNavigate } from 'react-router-dom';

const SearchBar = () => {
  const { searchItems, setSearchItems } = searchContext() as unknown as SearchContext;
  const [value, setValue] = useState('');
  const [_isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const identsParam = params.get('idents');

    if (identsParam === 'ALL' && setSearchItems) {
      setSearchItems([]);
    }
  }, [location.search]);

  useEffect(() => {
    // Clear searchbox on navigation changes
    setValue('');
  }, [location.pathname, location.search]);

  const handleDropdownToggle = (isOpen: boolean) => {
    setIsDropdownOpen(isOpen);
  };

  const handleTagClick = (item: Items) => {
    const params = new URLSearchParams(location.search);
    const idents = params.get('idents')?.split(',') ?? [];
    const newIdents = idents.filter(i => i !== item.id);

    if (newIdents.length > 0) {
      params.set('idents', newIdents.join(','));
    } 

    navigate({ search: params.toString() });
  };

  return (
    <div className="row">
      <div data-wow-delay="0.1s" className="col-12  wow fadeIn">
        <div className="search-input">
          <div id="app">
            {/* Tags */}
            <div id="tags" className="row flex-nowrap">
              <div className="col-11 etiquetas etpeq">
                {searchItems &&
                  searchItems.map((item, index) => (
                    <span
                      key={index}
                      title={tagMapping(item).tooltip}
                      onClick={() => {
                        if (setSearchItems) {
                          setSearchItems((prevItems: Items[]) =>
                            prevItems.filter(prevItem => prevItem !== item),
                          );
                        }
                        handleTagClick(item);
                      }}
                      data-testid="searchTag"
                    >
                      {tagMapping(item).text}
                    </span>
                  ))}
              </div>
              {searchItems!.length > 0 && (
                <SharedButton
                  id="clearAll"
                  size="xs"
                  onClick={e => {
                    e.preventDefault();
                    if (setSearchItems) setSearchItems([]);
                  }}
                  type="button"
                  className="BtnAccion mx-0 mb-2"
                  style={{ height: '25px', width: '10%', fontSize: '14px' }}
                >
                  Clear All
                </SharedButton>
              )}
            </div>
            <div>
              <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                <input
                  type="text"
                  autoComplete="off"
                  aria-autocomplete="list"
                  aria-controls="react-autowhatever-source"
                  placeholder="Examples: Obesity,  LEPR,  rs121913279,  streptozocin..."
                  value={value}
                  onChange={e => setValue(e.target.value)}
                />
                <div style={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)' }}>
                  <SearchButton
                    setValue={setValue}
                    className="first-button-class"
                    hasImg
                    imgSrc="../../static/images/button-1000x.png"
                  />
                </div>
              </div>
              {value.trim().length >= 3 && (
                <Dropdown
                  value={value}
                  setValue={setValue}
                  searchItems={searchItems as SearchItem[]}
                  setSearchItems={setSearchItems}
                  onDropdownToggle={handleDropdownToggle}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
